import React from "react";
import { FiEye } from "react-icons/fi";

export default function ViewOriginalButton({ onClick }) {
  return (
    <button type="button" className="view-original-button" aria-label="View original" title="View original" onClick={onClick}>
      <FiEye aria-hidden="true" />
    </button>
  );
}
